export enum BookingType {
    CREATED = 'CREATED',
    SYNCED = 'SYNCED'
}
